import { Image } from "@/components/Image";

export const CardImage = ({
  item: { primaryImage },
  ...props
}: {
  item: Travelguide.OOI;
}) => (
  <div className="w-full aspect-card">
    <Image
      image={primaryImage}
      bakeSettings={{ width: 720, height: 540 }}
      {...props}
      fill
    />
  </div>
);
